export default __webpack_public_path__ + "daff388e10001ec15a8f8c28533b384b.svg";